//region :: Imports ::
import {MNullable} from './Utils';
import MInvokeResult, {MValidationErrorsType} from './InvokeResult';

//endregion

/** */
class MInvokeObjectResult<TReply> {

    public readonly reply: MNullable<TReply>;
    public readonly validationErrors: MNullable<MValidationErrorsType>;
    public readonly exception: MNullable<any>;
    public readonly hasErrors: boolean;

    /** */
    private constructor(reply: MNullable<TReply>, validationErrors: MNullable<MValidationErrorsType>, exception: MNullable<any>) {

        this.reply = reply;
        this.validationErrors = validationErrors;
        this.exception = exception;
        this.hasErrors = reply === null && validationErrors !== null;

    }

    /** */
    public static ok<TReply>(reply: TReply): MInvokeObjectResult<TReply> {
        return new MInvokeObjectResult<TReply>(reply, null, null);
    }

    /** */
    public static notOk<TReply>(exception: any): MInvokeObjectResult<TReply> {

        const validationErrors = MInvokeResult.getValidationErrors(exception);

        if(validationErrors === null) {
            throw exception;
        }

        return new MInvokeObjectResult<TReply>(null, validationErrors, exception);

    }

}

export default MInvokeObjectResult;
